"use strict";
/**
 * @author Maxim Seredkin
 */
import angular from "angular";
import InvestPlanController from "./controller/invest-plan";
import InvestPlanService from "./service/invest-plan";
import PlanTableDirective from "./directive/planTable";
import PlanTableRowDirective from './directive/planTableRow';

export default angular
  .module("investmentProject.invest-plan", [])
  .controller("InvestPlanController", InvestPlanController)
  .directive('planTable', PlanTableDirective)
  .directive('planTableRow', PlanTableRowDirective)
  .factory("InvestPlanService", InvestPlanService).name;
